import { endYearActionTypes } from './end-year-pictures.type';

const INITIAL_STATE = {
  endYearList: [],
  isLoading: false,
  error: null,
  alert: {
    status: false,
    severity: 'success',
    titleMessage: '',
    subMessage: '',
  },
};

const endYearReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case endYearActionTypes.FETCH_END_YEAR_START:
    case endYearActionTypes.POST_END_YEAR_START:
    case endYearActionTypes.UPDATE_END_YEAR_START:
    case endYearActionTypes.DELETE_END_YEAR_START:
      return {
        ...state,
        isLoading: true,
      };
    case endYearActionTypes.FETCH_END_YEAR_SUCCESS:
      return {
        ...state,
        isLoading: false,
        endYearList: action.payload,
      };
    case endYearActionTypes.POST_END_YEAR_SUCCESS:
      return {
        ...state,
        isLoading: false,
        endYearList: [...state.endYearList, action.payload],
        alert: {
          status: true,
          severity: 'success',
          titleMessage: 'Success',
          subMessage: 'Content added successfully.',
        },
      };
    case endYearActionTypes.UPDATE_END_YEAR_SUCCESS:
      return {
        ...state,
        isLoading: false,
        endYearList: state.endYearList.map((item) => (item.id === action.payload.id ? action.payload : item)),
        alert: {
          status: true,
          severity: 'success',
          titleMessage: 'Success',
          subMessage: 'Content updated successfully.',
        },
      };
    case endYearActionTypes.DELETE_END_YEAR_SUCCESS:
      return {
        ...state,
        isLoading: false,
        endYearList: state.endYearList.filter((item) => item.id !== action.payload),
        alert: {
          status: true,
          severity: 'success',
          titleMessage: 'Success',
          subMessage: 'Content deleted successfully.',
        },
      };
    case endYearActionTypes.FETCH_END_YEAR_FAILED:
    case endYearActionTypes.POST_END_YEAR_FAILED:
    case endYearActionTypes.UPDATE_END_YEAR_FAILED:
    case endYearActionTypes.DELETE_END_YEAR_FAILED:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        alert: {
          status: true,
          severity: 'error',
          titleMessage: 'Error',
          subMessage: action.payload,
        },
      };
    case endYearActionTypes.HIDE_ALERT:
      return {
        ...state,
        alert: {
          ...state.alert,
          status: false,
        },
      };
    default:
      return state;
  }
};

export default endYearReducer;
